<template>
  <LoadingContainer
    :is-loaded="isLoaded"
    :total="subjectsLength"
    kind="Subjects"
  >
    <ul class="subject-picker" slot="default">
      <li v-for="s in subjects" :key="s.id">
        <ColorButton
          :color="s.color"
          class="subject-picker__button"
          tag="router-link"
          :to="{
            name: 'new-preset',
            params: {
              subjectId: s.id
            }
          }"
        >
          Log <b>{{ s.name }}</b> Activity
        </ColorButton>
      </li>
    </ul>

    <router-link
      slot="button"
      class="button button--border"
      :to="{
        name: 'settings-subjects',
        query: {
          add: true
        }
      }"
      replace
    >
      Add Subject
    </router-link>
  </LoadingContainer>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'ChooseSubject',

  computed: {
    ...mapGetters({
      isLoaded: 'subjects/isLoaded',
      subjectsLength: 'subjects/subjectsLength',
      subjects: 'subjects/sortedSubjects'
    })
  },

  mounted () {
    store.dispatch('subjects/getSubjects')
  }
}
</script>

<style lang="scss" scoped>
.subject-picker {
  margin: 0;
  padding: 1rem 0;
  width: 100%;
  list-style: none;
}

li {
  margin-bottom: 1rem;
  width: 100%;
}
</style>
